module.exports = __webpack_public_path__ + "static/media/title_dlc_04.828ffa36.png";